<script>
export default {
  name: 'EditBookingSkeleton',
}
</script>

<template>
  <v-container fluid class="edit-booking-skeleton py-6">
    <v-row justify="center">
      <v-col cols="12">
        <v-skeleton-loader
          class="mb-6"
          type="heading"
          height="40"
          width="60%"
        ></v-skeleton-loader>

        <v-skeleton-loader
          class="rounded-xl mb-6"
          type="image"
          height="220"
        ></v-skeleton-loader>

        <v-card flat class="pa-4 rounded-xl">
          <v-skeleton-loader
            v-for="i in 4"
            :key="'field-' + i"
            class="mb-4"
            type="text"
            height="24"
            width="100%"
          ></v-skeleton-loader>

          <v-row class="mt-6" justify="space-between">
            <v-col cols="5">
              <v-skeleton-loader
                type="button"
                height="40"
                width="100%"
              ></v-skeleton-loader>
            </v-col>
            <v-col cols="5">
              <v-skeleton-loader
                type="button"
                height="40"
                width="100%"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import '@styles';

.edit-booking-skeleton {
  .v-skeleton-loader {
    background: #fafafa !important;
    border-radius: 12px;
  }

  .v-skeleton-loader__bone {
    background: linear-gradient(90deg, #f2f2f2 25%, #e9e9e9 50%, #f2f2f2 75%);
    background-size: 400% 100%;
    animation: shimmer 1.6s infinite;
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}
</style>
